<template>
  <div class="audit-export">
    <div class="h-panel-body padding-top">
      <Alert class="margin-right-left" type="info">
        按照国家标准 GB/T 24589.1-2024《财经信息技术 会计核算软件数据接口 第1部分：企业》导出审计数据包（ZIP）。
      </Alert>

      <Card class="margin-right-left margin-top" dis-hover>
        <Row type="flex" align="middle" :space-x="15">
          <Cell>
            <span>会计年度：</span>
          </Cell>
          <Cell>
            <DatePicker v-model="year" type="year" format="yyyy" style="width:130px" placeholder="选择年度"></DatePicker>
          </Cell>
          <Cell>
            <Button color="primary" icon="h-icon-download" @click="doExport">导出审计数据包</Button>
          </Cell>
        </Row>
      </Card>

      <Card class="margin-right-left margin-top" dis-hover title="数据包内容">
        <ul class="file-list">
          <li><b>ggdz.xml</b> —— 公共档案（企业信息、会计期间、会计科目、员工档案）</li>
          <li><b>kmye.xml</b> —— 科目余额（期初、本年借贷发生、期末余额）</li>
          <li><b>jzpz.xml</b> —— 记账凭证（凭证主表与明细分录，仅正式凭证）</li>
          <li><b>gdzc.xml</b> —— 固定资产（卡片、原值、折旧、净值）</li>
          <li><b>ygxc.xml</b> —— 员工薪酬（所选年度的工资、社保、公积金、个税）</li>
        </ul>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditExport',
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  methods: {
    doExport() {
      if (!this.year) {
        this.$Message.warning('请选择会计年度');
        return;
      }
      //DatePicker 返回 Date 对象，需取年份数值，否则后端解析失败会静默回退当前年
      const y = this.year instanceof Date ? this.year.getFullYear() : parseInt(this.year, 10);
      const currentYear = new Date().getFullYear();
      if (!y) {
        this.$Message.warning('会计年度无效');
        return;
      }
      if (y < 2000 || y > currentYear + 1) {
        this.$Message.warning('会计年度无效，请选择 2000 至 ' + (currentYear + 1) + ' 之间的年度');
        return;
      }
      window.open(this.$api.pro.auditUrl(y), '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.audit-export {
  .margin-top {
    margin-top: 12px;
  }
  .file-list {
    padding-left: 20px;
    line-height: 2;
    color: #515a6e;
  }
}
</style>
